import type { FC, SVGProps } from 'react';

export const ColorIcon: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 16 16"
        width="16.000000"
        height="16.000000"
        fill="currentColor"
        //customFrame="#000000"
        {...props}
    >
        <rect
            id="цвет"
            width="16.000000"
            height="15.999999"
            x="0.000000"
            y="0.000000"
            rx="2.000000"
            fill="currentColor"
            transform="matrix(-4.37114e-08,1,-1,-4.37114e-08,16,0)"
        />
        <path
            id="Rectangle 3518"
            d="M0.341421 0.341421L5.65858 5.65858C5.78457 5.78457 5.69534 6 5.51716 6L0.2 6C0.089543 6 -8.74228e-09 5.91046 -8.74228e-09 5.8L-2.11057e-08 0.482843C-2.11057e-08 0.304662 0.215428 0.215428 0.341421 0.341421Z"
            fill="rgb(249,250,251)"
            fillRule="nonzero"
            transform="matrix(-4.37114e-08,-1,1,-4.37114e-08,7,13)"
        />
        <path
            id="Rectangle 3518"
            d="M5.11116 5.11116L5.65858 5.65858C5.78457 5.78457 5.69534 6 5.51716 6L0.2 6C0.089543 6 0 5.91046 0 5.8L0 0.482843C0 0.304662 0.215428 0.215428 0.341421 0.341421L5.11116 5.11116ZM3.58579 5L1 2.41421L1 5L3.58579 5Z"
            fill="rgb(246.517,246.517,246.517)"
            fillRule="evenodd"
            transform="matrix(-4.37114e-08,-1,1,-4.37114e-08,7,13)"
        />
    </svg>
);
